import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, onPrepareHeaders } from "@/redux/services/helpers";
import {
  REDUCER_PATH,
  RELATED_TAGS,
} from "@/modules/contacts/features/borrower/utils/borrower-service-tags";

export const borrowerService = createApi({
  reducerPath: REDUCER_PATH,
  tagTypes: RELATED_TAGS,
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: onPrepareHeaders,
  }),
  endpoints: () => ({}),
});

